import { AuthGuard } from '@app/common';

export const routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'admin',
    loadChildren: '../layout/layout.module#LayoutModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'activation',
    loadChildren: './activation/activation.module#ActivationModule'
  },
  {
    path: 'login',
    loadChildren: './pages/login/login.module#LoginModule',
  },
  {
    path: 'view-po/:id',
    loadChildren: './view-po/view-po.module#ViewPoModule'
  },
  {
    path: 'view-payment-order/:id',
    loadChildren: './view-invoice/view-invoice.module#ViewInvoiceModule'
  },
  {
    path: 'recover',
    loadChildren: './pages/recover/recover.module#RecoverModule'
  },
  {
    path: 'reset-password/:token',
    loadChildren: './pages/reset-password/reset-password.module#ResetPasswordModule'
  },
  {
    path: 'browser-not-supported',
    loadChildren: './pages/browser-compatibilty/browser-compatibilty.module#BrowserCompatibiltyModule'
  },
  {
    path: 'project/:projectId/prep/daily-schedule/history',
    loadChildren: './pages/prep-listing/prep-listing.module#PrepListingModule',
    data: {
      type: 'dailySchedule'
    }
  },
  {
    path: 'project/:projectId/prep/daily-schedule',
    loadChildren: './projects/manage-project/prep/manage-prep/daily-schedule/manage-daily-schedule/manage-daily-schedule.module#ManageDailyScheduleModule',
    data: {
      isReadOnly: true
    }
  },
  {
    path: 'project/:projectId/prep/director-scout/history',
    loadChildren: './pages/prep-listing/prep-listing.module#PrepListingModule',
    data: {
      type: 'directorScout'
    }
  },
  {
    path: 'project/:projectId/prep/directors-scout',
    loadChildren: './projects/manage-project/prep/manage-prep/directors-scout/manage-directors-scout/manage-directors-scout.module#ManageDirectorsScoutModule',
    data: {
      isReadOnly: true
    }
  },
  // {
  //   path: 'project/:projectId/prep/director-scout/history',
  //   loadChildren: './pages/prep-listing/prep-listing.module#PrepListingModule',
  //   data: {
  //     type: 'directorScout'
  //   }
  // },
  // {
  //   path: 'project/:projectId/prep/director-scout',
  //   loadChildren: './projects/manage-project/prep/manage-prep/director-scout/manage-director-scout/manage-director-scout.module#ManageDirectorScoutModule',
  //   data: {
  //     isReadOnly: true
  //   }
  // },
  {
    path: 'project/:projectId/prep/travel-movement/history',
    loadChildren: './pages/prep-listing/prep-listing.module#PrepListingModule',
    data: {
      type: 'travelMovement'
    }
  },
  {
    path: 'project/:projectId/prep/travel-movement',
    loadChildren: './projects/manage-project/prep/manage-prep/travel-movement/manage-travel-movement/manage-travel-movement.module#ManageTravelMovementModule',
    data: {
      isReadOnly: true
    }
  },
  {
    path: 'project/:projectId/prep/call-sheet/history',
    loadChildren: './pages/prep-listing/prep-listing.module#PrepListingModule',
    data: {
      type: 'callSheet'
    }
  },
  {
    path: 'project/:projectId/prep/call-sheet',
    loadChildren: './projects/manage-project/prep/manage-prep/call-sheet/manage-call-sheet/manage-call-sheet.module#ManageCallSheetModule',
    data: {
      isReadOnly: true
    }
  },
  { path: '**', redirectTo: 'admin' }
];



// WEBPACK FOOTER //
// ./src/app/routes/routes.ts